import { getCatalogState } from '../feature.selector';
import { CatalogState } from '../state';
import { createSelector } from '@ngrx/store';
import { SortState } from './sort.state';

export const getSortState = createSelector(getCatalogState,
  (state: CatalogState) => state && state.sort
);

export const getSortOption = createSelector(getSortState,
  (state: SortState) => state && state.sortOption
);
